import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { recaptchaToken } from "@/lib/recaptcha";
import { usePlayer } from "@/lib/asv";

export function ForgotForm({ onBack }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/asv/auth/forgot", { email, recaptcha_token: await recaptchaToken("forgot", "asv") });
      setSent(true);
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="asv-card mt-8 space-y-3 p-6" data-testid="forgot-form">
      {sent ? <p className="text-center text-sm" data-testid="forgot-sent">If that email has an account, a reset link is on its way. Check your inbox.</p>
        : <><p className="asv-muted text-sm">Enter your email and we'll send you a link to reset your password.</p>
          <input type="email" className="asv-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          <button className="asv-btn w-full" disabled={busy} data-testid="forgot-submit">Send reset link</button></>}
      <button type="button" className="asv-muted w-full text-sm" onClick={onBack} data-testid="forgot-back">Back to sign in</button>
    </form>
  );
}

export function ResetForm({ token }) {
  const nav = useNavigate();
  const { refresh } = usePlayer();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/asv/auth/reset", { token, password: pw.a });
      toast.success("Password updated");
      if (data.staff) { window.location.href = "/signin?next=/platform"; return; }
      await refresh(); nav("/account");
    }
    catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="asv-card mt-8 space-y-3 p-6" data-testid="reset-form">
      <input type="password" className="asv-input" placeholder="New password (min 8)" minLength={8} value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} required data-testid="reset-password" />
      <input type="password" className="asv-input" placeholder="Confirm new password" minLength={8} value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} required data-testid="reset-password-confirm" />
      <button className="asv-btn w-full" disabled={busy} data-testid="reset-submit">Set new password</button>
    </form>
  );
}
